"use client"

import { useRouter, usePathname, useSearchParams } from "next/navigation"
import { useTranslations } from "next-intl"
import type { SortOrder } from "@/lib/graphql/types"

interface SortSelectorProps {
  sortOrders: SortOrder[]
  activeSort: string
}

export function SortSelector({ sortOrders, activeSort }: SortSelectorProps) {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const t = useTranslations("filters")

  if (sortOrders.length === 0) {
    return null
  }

  function handleChange(value: string) {
    const params = new URLSearchParams(searchParams.toString())
    if (value) {
      params.set("sort", value)
    } else {
      params.delete("sort")
    }
    // Reset pagination when sort changes
    params.delete("page")
    const qs = params.toString()
    router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false })
  }

  return (
    <select
      aria-label={t("sort")}
      value={activeSort || sortOrders[0]?.key || ""}
      onChange={(e) => handleChange(e.target.value)}
      className="rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      {sortOrders.map((so) => (
        <option key={so.key} value={so.key}>
          {so.title}
        </option>
      ))}
    </select>
  )
}
